import http from "./http"
import HelperService from "../services/helper"
import { Pagination, QueryParams } from "../models/misc"
import { LeagueStats, PlayerStats } from "../models/leagueStats"

class LeagueStatsService {
  private readonly baseUrl = "/league-stats"

  async listPlayerLeagueStats(id: string, filters?: QueryParams) {
    const queryString = HelperService.buildSearchQueryString(filters)
    const { data } = await http.get<Pagination<PlayerStats>>(
      `${this.baseUrl}/${id}/player-stats${queryString}`
    )
    return data
  }

  async getLeagueStats(leagueId: string) {
    const { data } = await http.get<LeagueStats>(`${this.baseUrl}/${leagueId}`)
    return data
  }
}

export default new LeagueStatsService()
